import { Box, Button, ITheme, ListItemText, Menu, MenuItem, Typography, useTheme } from '@mui/material';
import React from 'react';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { useTranslation } from 'react-i18next';
import { useAppDispatch, useAppSelector } from '../../store/reducers/store';
import { PortfolioTimeline } from '../../models/Portfolio';
import { setTimeline } from '../../store/actions/portfolioDetails';

const TimelineSelector: React.FC = () => {
    const theme = useTheme() as ITheme;
    const { t } = useTranslation();
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);
    const timeline = useAppSelector(state => state.portfolioDetails.timeline);
    const dispatch = useAppDispatch();

    const handleClick = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    const onChangeTimeline = (timeline: PortfolioTimeline): void => {
        dispatch(setTimeline(timeline));
        handleClose();
    }
    const getTimelineName = (timeline: PortfolioTimeline): string => {
        switch (timeline) {
            case PortfolioTimeline.ThreeMonth:
                return t('PortfolioDetailsSelectTimeline3Month');
            case PortfolioTimeline.SixMonth:
                return t('PortfolioDetailsSelectTimeline6Month');
            case PortfolioTimeline.OneYear:
                return t('PortfolioDetailsSelectTimeline1Year');
            case PortfolioTimeline.TwoYears:
                return t('PortfolioDetailsSelectTimeline2Years');
        }
    }

    return <></> //Deactivated on demand of customer
    // return <>
    //     <Button
    //         id="timeline-button"
    //         aria-controls={open ? 'timeline-button-menu' : undefined}
    //         aria-haspopup="true"
    //         aria-expanded={open ? 'true' : undefined}
    //         variant="outlined"
    //         color='info'
    //         disableElevation
    //         onClick={handleClick}
    //         endIcon={<KeyboardArrowDownIcon sx={{ color: theme.palette.leo.type[900]}} />}
    //     >
    //         <Box display={"flex"} flexDirection={"column"} gap={"5px"} alignItems={"start"}>
    //             <Typography fontSize={"12px"} lineHeight={"12px"} fontWeight={"600"} color={theme.palette.leo.type[600]}>{t('PortfolioDetailsSelectTimelineTitle')}</Typography>
    //             <Typography fontSize={"12px"} lineHeight={"12px"} fontWeight={"600"}>{getTimelineName(timeline)}</Typography>
    //         </Box>
    //     </Button>
    //     <Menu
    //         MenuListProps={{
    //             'aria-labelledby': 'timeline-button',
    //         }}
    //         anchorEl={anchorEl}
    //         open={open}
    //         onClose={handleClose}
    //     >
    //         <MenuItem onClick={() => onChangeTimeline(PortfolioTimeline.ThreeMonth)}>
    //             <ListItemText>{getTimelineName(PortfolioTimeline.ThreeMonth)}</ListItemText>
    //         </MenuItem>
    //         <MenuItem onClick={() => onChangeTimeline(PortfolioTimeline.SixMonth)}>
    //             <ListItemText>{getTimelineName(PortfolioTimeline.SixMonth)}</ListItemText>
    //         </MenuItem>
    //         <MenuItem onClick={() => onChangeTimeline(PortfolioTimeline.OneYear)}>
    //             <ListItemText>{getTimelineName(PortfolioTimeline.OneYear)}</ListItemText>
    //         </MenuItem>
    //         <MenuItem onClick={() => onChangeTimeline(PortfolioTimeline.TwoYears)}>
    //             <ListItemText>{getTimelineName(PortfolioTimeline.TwoYears)}</ListItemText>
    //         </MenuItem>
    //     </Menu>
    // </>;
}

export default TimelineSelector;